import { AdjustmentStatuses } from 'constants/adjustmentStatuses';

import { OrderAdjustments } from 'types/embedded/orderAdjustments';

const RED_COLOR = '#FEEBEE';

const ColorConfig: Record<string, string> = {
  [AdjustmentStatuses.Rejected]: RED_COLOR,
};

export const getRowStyle = (record: OrderAdjustments) =>
  record?.adjustmentStatus && ColorConfig[record.adjustmentStatus.value]
    ? { background: ColorConfig[record.adjustmentStatus.value] }
    : { background: 'white' };
